import { Signal, WritableSignal, inject, signal } from '@angular/core';

import { TiimeOverlayRef } from './overlay.ref';
import { TIIME_OVERLAY_DATA } from './overlay.token';

export abstract class OverlayBase<Result = any, Data = any> {
  readonly overlayData: Signal<Data> = signal(inject(TIIME_OVERLAY_DATA)).asReadonly();
  readonly loading: WritableSignal<boolean> = signal<boolean>(false);

  protected readonly overlayRef: TiimeOverlayRef = inject(TiimeOverlayRef);

  set isLoading(isLoading: boolean) {
    this.loading.set(isLoading);
  }

  close(value: Result): void {
    this.overlayRef.close(value);
  }

  cancel(): void {
    this.overlayRef.close();
  }
}
